var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-app-page"},[_c('t-update-version',{on:{"update-now":_vm.updateNow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }